export default __webpack_public_path__ + "static/media/join.2c53f1a0.png";